import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { BaseReport } from './BaseReport';

export class TrialBalanceReport extends BaseReport {
    _originalTypeClassName = "zERP.BO.TrialBalanceReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TrialBalanceReport.translate = translateService;
}
super();
this.Lines = [];
this.Sums = [];
this.TreeItems = [];
this.Type = null;
this.AdjustingColumnHandling = null;
this.ColumnTitles = null;
this._key = this.BaseReportKey = 0; 
}

static translate: TranslateService;
_key: any;
Type:any;
AdjustingColumnHandling:any;
ColumnTitles:any;
Lines:any;
Sums:any;
TreeItems:any;
static setLines = ($this, items) => {
                if (items == null) items = [];
                if ($this.Lines == null) $this.Lines = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Lines.length > 0) {
                    Domain.TrialBalanceReport.removeLines($this, $this.Lines[0]);
                }

                Domain.TrialBalanceReport.addManyLines($this, copyItems);
            }
static addManyLines = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TrialBalanceReport.addLines($this, items[i]);
                }
            }
static addLines = ($this, item) => {
                if ($this.Lines == null) $this.Lines = [];
                if (item == null || $this.Lines.indexOf(item) > -1) return;
                $this.Lines.push(item);
}
static addRangeLines = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TrialBalanceReport.addLines($this, item));
            }
static removeLines = ($this, item) => {
                if ($this == null || $this.Lines == null || $this.Lines.indexOf(item) === -1) return;
                var _index = $this.Lines.indexOf(item);
                $this.Lines.splice(_index, 1);
}
static clearLines = ($this) => { $this.Lines = null; }
static setSums = ($this, items) => {
                if (items == null) items = [];
                if ($this.Sums == null) $this.Sums = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Sums.length > 0) {
                    Domain.TrialBalanceReport.removeSums($this, $this.Sums[0]);
                }

                Domain.TrialBalanceReport.addManySums($this, copyItems);
            }
static addManySums = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TrialBalanceReport.addSums($this, items[i]);
                }
            }
static addSums = ($this, item) => {
                if ($this.Sums == null) $this.Sums = [];
                if (item == null || $this.Sums.indexOf(item) > -1) return;
                $this.Sums.push(item);
}
static addRangeSums = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TrialBalanceReport.addSums($this, item));
            }
static removeSums = ($this, item) => {
                if ($this == null || $this.Sums == null || $this.Sums.indexOf(item) === -1) return;
                var _index = $this.Sums.indexOf(item);
                $this.Sums.splice(_index, 1);
}
static clearSums = ($this) => { $this.Sums = null; }
static setTreeItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.TreeItems == null) $this.TreeItems = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TreeItems.length > 0) {
                    Domain.TrialBalanceReport.removeTreeItems($this, $this.TreeItems[0]);
                }

                Domain.TrialBalanceReport.addManyTreeItems($this, copyItems);
            }
static addManyTreeItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TrialBalanceReport.addTreeItems($this, items[i]);
                }
            }
static addTreeItems = ($this, item) => {
                if ($this.TreeItems == null) $this.TreeItems = [];
                if (item == null || $this.TreeItems.indexOf(item) > -1) return;
                $this.TreeItems.push(item);
}
static addRangeTreeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TrialBalanceReport.addTreeItems($this, item));
            }
static removeTreeItems = ($this, item) => {
                if ($this == null || $this.TreeItems == null || $this.TreeItems.indexOf(item) === -1) return;
                var _index = $this.TreeItems.indexOf(item);
                $this.TreeItems.splice(_index, 1);
}
static clearTreeItems = ($this) => { $this.TreeItems = null; }

static AutoFillDates($this: any): any{if ($this?.Period != null) {$this.From = $this?.Period?.StartDate;$this.To = $this?.Period?.EndDate;}
}
static ExpandAll($this: any): any{let expand = !($this?.Lines?.linq?.where()?.firstOrDefault(null)?.Expanded);
for (let _iline = 0; _iline < ($this?.Lines == null ? 0 : $this?.Lines.length); _iline++) {let line = $this?.Lines[_iline];line.Expanded = !(expand);Domain.TrialBalanceReportLine.ToggleExpand(line, $this?.Lines);}
}
static GetTitles($this: any): any{let titles = [];
let col1Title = "Απογραφή";
let col2Title = "Προηγούμενο Υπόλοιπο";
let col3Title = "Κίνηση Περιόδου";
let col4Title = "Προοδευτικά Σύνολα";
let col5Title = "Νέο Υπόλοιπο";
let dateFormat = "dd/MM/yyyy";
let d1 = CLMS.Framework.DateTime.ToString($this?.FiscalPeriod?.StartDate, dateFormat);
let d2 = CLMS.Framework.DateTime.ToString($this?.From, dateFormat);
let d3 = CLMS.Framework.DateTime.ToString($this?.To, dateFormat);
let p2 = d1 + " - " + d2;
let p3 = d2 + " - " + d3;
let p4 = d1 + " - " + d3;
let p5 = d3;
if ($this?.ColumnTitles == Domain.TrialBalanceColumnTitles.Period) {col1Title = col1Title;col2Title = p2;col3Title = p3;col4Title = p4;col5Title = p5;}
if ($this?.ColumnTitles == Domain.TrialBalanceColumnTitles.TextAndPeriod) {col1Title = col1Title;col2Title = col2Title + " " + p2;col3Title = col3Title + " " + p3;col4Title = col4Title + " " + p4;col5Title = col5Title + " " + p5;}
return [col1Title, col2Title, col3Title, col4Title, col5Title];
}
static PrepareChildAccounts($this: any, accounts: any): any{let childAccounts = new window['Map']();
for (let _iacc = 0; _iacc < (accounts?.linq?.orderByDescending((a) => a.Level)?.toArray()?.linq?.where((a) => CLMS.Framework.Number.Equal(() => a.AccountSign, () => 3))?.toArray() == null ? 0 : accounts?.linq?.orderByDescending((a) => a.Level)?.toArray()?.linq?.where((a) => CLMS.Framework.Number.Equal(() => a.AccountSign, () => 3))?.toArray().length); _iacc++) {let acc = accounts?.linq?.orderByDescending((a) => a.Level)?.toArray()?.linq?.where((a) => CLMS.Framework.Number.Equal(() => a.AccountSign, () => 3))?.toArray()[_iacc];let parent = acc.ParentChartOfAccount;if (CLMS.Framework.Number.NotEqual(() => parent, () => null) && CLMS.Framework.Number.GreaterThan(() => parent, () => 0) && !(childAccounts.has(parent))) {childAccounts.set(parent, true);}}
return childAccounts;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BaseReportKey == null || $this.BaseReportKey == 0;
            }


}